import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=2dae1cb8"
import script from "./Overlay.vue?vue&type=script&lang=ts"
export * from "./Overlay.vue?vue&type=script&lang=ts"
import style0 from "./Overlay.vue?vue&type=style&index=0&id=2dae1cb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports